import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../Service/auth';
import { ToastService } from '../Service/toast-service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const toastService = inject(ToastService);
  const platformId = inject(PLATFORM_ID);

  console.group('🛡️ [LOG AUTH_GUARD] Analizando Acceso a Ruta:', state.url);

  // 1. Blindaje SSR indispensable contra Node.js
  if (!isPlatformBrowser(platformId)) {
    console.groupEnd();
    return true; 
  }

  // 2. Recuperamos los roles de la f0002_user guardados en el navegador
  const rolesUsuario = authService.getRoles();
  console.log('Roles que el usuario tiene asignados:', rolesUsuario);

  // 🚀 FIX CONTRA REBOTE: Si el usuario no tiene roles cargados en memoria, al Login de inmediato
  if (!rolesUsuario || rolesUsuario.length === 0) {
    console.error('❌ No se detectó ninguna sesión activa en LocalStorage. Rebote preventivo.');
    console.groupEnd();
    router.navigate(['/login']);
    return false;
  }

  // 3. 🚀 EXTRACCIÓN CANDADO POR ROL: Leemos qué roles exige la pantalla solicitada
  const rolesPermitidosEnPantalla = route.data['rolesPermitidos'] as Array<string>;
  console.log('Roles requeridos para abrir esta pantalla:', rolesPermitidosEnPantalla);

  // Si la ruta no tiene restricciones específicas configuradas (ej: es libre), abrimos compuerta
  if (!rolesPermitidosEnPantalla || rolesPermitidosEnPantalla.length === 0) {
    console.log('🔓 Ruta libre de candados de rol específicos. Acceso concedido.');
    console.groupEnd();
    return true;
  }

  // 4. MATEMÁTICA DE INTERSECCIÓN DE PERMISOS:
  // Evaluamos si AL MENOS UNO de los roles del empleado coincide con los permitidos en la pantalla
  const tienePermisoLegal = rolesUsuario.some(rol => rolesPermitidosEnPantalla.includes(rol));

  if (tienePermisoLegal) {
    console.log('✅ Acceso AUTORIZADO por jerarquía de roles de la UDC.');
    console.groupEnd();
    return true;
  }

  // 5. PENALIZACIÓN DE INTRUSIÓN: Si es Asesor e intenta meterse a Seguridad, lo bloqueamos
  console.error('🚫 Intento de violación de privilegios detectado. Usuario no autorizado para esta sección.');
  console.groupEnd();

  toastService.showDanger(
    'Privilegios Insuficientes', 
    'Su perfil de cuenta no cuenta con las facultades requeridas para operar este módulo.'
  );

  // En lugar de mandarlo al login y romper su flujo, lo dejamos en Clientes que es su área de trabajo ordinaria
  router.navigate(['/home']);
  return false;
};